// src/plugins/global-components.js
import {
    BCard, BButton, BTable, BOverlay, BFormSelect, BFormGroup, BCol, BFormInput, BRow, BImg,BFormRow,BFormFile,BNavItem,BTd,BNav,BFormTextarea,BAlert,BModal,BDropdown
    ,BDropdownItem,BInputGroup,BFormCheckbox,BProgress,BFormSelectOption,BPagination,BFormCheckboxGroup,BCollapse,VBToggle,BAccordion,
    BAccordionItem,BCardBody,BCardTitle
  } from 'bootstrap-vue-next';
  
  export default {
    install(app) {
      app.component('BCard', BCard);
      app.component('BButton', BButton);
      app.component('BTable', BTable);
      app.component('BOverlay', BOverlay);
      app.component('BFormSelect', BFormSelect);
      app.component('BFormGroup', BFormGroup);
      app.component('BCol', BCol);
      app.component('BFormInput', BFormInput);
      app.component('BRow', BRow);
      app.component('BImg', BImg);
      app.component('BFormRow', BFormRow);
      app.component('BFormFile', BFormFile);
      app.component('BNavItem', BNavItem);
      app.component('BTd', BTd); 

      app.component('BNav', BNav);
      app.component('BFormTextarea', BFormTextarea);
      app.component('BAlert', BAlert);
      app.component('BModal', BModal);
      app.component('BDropdown', BDropdown);
      app.component('BDropdownItem', BDropdownItem);
      app.component('BInputGroup', BInputGroup);
      app.component('BFormCheckbox', BFormCheckbox);
      app.component('BFormCheckboxGroup', BFormCheckboxGroup);

      app.component('BProgress', BProgress);
      app.component('BFormSelectOption', BFormSelectOption);
      app.component('BPagination', BPagination); 
      app.component('BCollapse', BCollapse);
      app.component('VBToggle', VBToggle);
      app.component('BAccordion', BAccordion);
      app.component('BAccordionItem', BAccordionItem);
      app.component('BCardBody', BCardBody);
      app.component('BCardTitle', BCardTitle);
      














    }
  };
  